import { gql } from "../../../lib/Apollo"

export const CHECKCODE = gql`
  query ($code: String!, $surveyId: ID!) {
    isSubmissionCodeValid(code: $code, surveyId: $surveyId) {
      isValid
      id
    }
  }
`

export const LOAD = gql`
  query ($id: ID!) {
    getSurvey(surveyId: $id) {
      type
      id
      title
      richTitle
      status
      features {
        headerLogo
      }
      introduction {
        type
        content
      }
      richIntroduction
      languages {
        code
        name
        nativeName
      }
      meta {
        isAnonymous
        anonymityType
        brand {
          colour
          logo
        }
        private
        mode {
          shareableLinks
          uniqueSubmission
          emailIndividualResult
        }
        isolated
      }
      template {
        id
        branchingLogic {
          targetAnswers
          targetSection
          targetQuestion
          choice
          currentQuestion
        }

        questions {
          type
          id
          title
          richTitle
          required
          description
          richDescription
          icon
          ... on ScaleQuestion {
            isCore
            min
            max
          }
          ... on DropdownQuestion {
            label
            isCore
            values {
              id
              value
            }
          }
          ... on SmileyFaceQuestion {
            label
            values {
              id
              value
              smileyValue
            }
          }
          ... on RadioQuestion {
            isCore
            values {
              id
              value
            }
          }
          ... on ShortTextQuestion {
            isCore
            fields {
              label
              limit
              type
            }
          }
          ... on CheckboxQuestion {
            isCore
            label
            enabled
            allowOther
            validation {
              min
              max
              exact
              errorMessage
            }
            values {
              id
              value
            }
          }
        }
        sections {
          name
          richName
          visible
          description {
            type
            content
          }
          richDescription
          questions
        }
      }
    }
  }
`

export const SUBMIT = gql`
  mutation (
    $id: ID!
    $templateId: ID!
    $answers: [SurveyAnswerInput]!
    $code: String
    $language: String
    $savantaId: ID
    $optionalUserEmail: String
    $isAnonymous: Boolean
  ) {
    createSurveySubmission(
      surveyId: $id
      surveyTemplateId: $templateId
      answers: $answers
      code: $code
      language: $language
      savantaId: $savantaId
      optionalUserEmail: $optionalUserEmail
      isAnonymous: $isAnonymous
    )
  }
`

export const ATTACH_USER = gql`
  mutation ($id: ID!, $token: String) {
    attachUserToSurveySubmission(surveySubmissionId: $id, token: $token)
  }
`
